// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__9WAJ1","primaryBtn":"Button_primaryBtn__um0Ui","secondaryBtn":"Button_secondaryBtn__5gi9B"};